import { render } from "./DropdownBody.vue?vue&type=template&id=2a919400"
import script from "./DropdownBody.vue?vue&type=script&lang=js"
export * from "./DropdownBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__